var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.open
    ? _c(
        "m-linear-progress",
        _vm._g(
          _vm._b(
            { attrs: { indeterminate: _vm.indeterminate, open: _vm.open } },
            "m-linear-progress",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }